import React from 'react'
import { Field } from 'formik'
import { IMediaType } from '../../../types/mediaType'
import { CustomCheckboxField, H3, P } from '../../../components'

interface IMediaTypesTableRow {
  editable?: boolean
  mediaType: IMediaType
}

export const MediaTypesTableRow = ({ mediaType, editable = true }: IMediaTypesTableRow) => (
  <tr key={mediaType.extension}>
    <td>
      <Field
        name={mediaType.extension.replace('.', '')}
        component={CustomCheckboxField}
        disabled={!editable}
      />
    </td>
    <td>
      <H3>{mediaType.title}</H3>
    </td>
    <td>
      <P>{mediaType.mediaContentType}</P>
    </td>
    <td>
      <P>{mediaType.extension}</P>
    </td>
    <td>
      <P>{mediaType.mimeType}</P>
    </td>
  </tr>
)
